(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$rootScope', '$http'];

    function PasswordResetInit($rootScope, $http) {
        var service = {
            resetPassword: resetPassword
        }

        return service;

        function resetPassword(id, user){
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + id + '/changePassword',
                data: user
            });
        }
    }
})();
